export default "__VITE_ASSET__DoVn1fJI__"